import React from 'react';
import './Styles.css';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { isTeamQueryValid } from '../../Functions';
import { useNavigate } from 'react-router-dom';
import { Ui24AddUser } from '@ids/react-icons';
import PrimaryButton from '../../../../Elements/ids/Buttons/PrimaryButton';

const TeamSearchResults = ({ results, query, resultSummary }) => {
  const navigate = useNavigate();

  return (
    <div className="searchPage-teamResults-container">
      <div className="searchPage-teamResults-title">{resultSummary}</div>
      {results.length === 0 ? (
        <>
          {isTeamQueryValid(query) && (
            <div className="searchPage-teamResults-createButton">
              <PrimaryButton
                text={formatMessage(Messages.searchPage_createTeamButton)}
                onClickEvent={() => {
                  navigate('/team/add', { state: { codePrefix: query } });
                }}
              />
            </div>
          )}
        </>
      ) : (
        <>
          <div className="common-table-row searchPage-teamResults-row headerRow">
            <div></div>
            <div>{formatMessage(Messages.common_name)}</div>
            <div>{formatMessage(Messages.common_userId)}</div>
            <div>{formatMessage(Messages.common_codePrefix)}</div>
            <div>{formatMessage(Messages.common_agentCode)}</div>
            <div>{formatMessage(Messages.common_costCenter)}</div>
          </div>
          {results.map((team, index) => (
            <div
              key={team.id ?? 0}
              className={`common-table-row searchPage-teamResults-row clickable ${
                index % 2 === 1 ? 'common-table-evenRow' : ''
              }`}
              onClick={() => {
                if (team.isFromAD) {
                  navigate(`/team/add`, { state: { ...team, codePrefix: team.userId } });
                  return;
                }
                navigate(`/team/view/${team.codePrefix}`);
              }}>
              <div className="searchPage-teamResults-icon">
                {team.isFromAD ? (
                  <Ui24AddUser />
                ) : (
                  <img aria-hidden className="if size-24" src="/assets/people.svg" alt="Team" />
                )}
              </div>
              <div>{team.name}</div>
              <div>{team.userId}</div>
              <div>{team.codePrefix}</div>
              <div>
                <ul className="searchPage-teamResults-internalList">
                  {team.agents.map((agent, index) => (
                    <li key={index}>{agent.code}</li>
                  ))}
                </ul>
              </div>
              <div>
                <ul className="searchPage-teamResults-internalList">
                  {team.agents.map((agent, index) => (
                    <li key={index}>{agent.costCenterName}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default TeamSearchResults;
